module.exports = "/_next/static/images/b63b87c6f785737e6840be901dddd838-check.svg.webp";